import React from 'react'

import SerializableFilePickerInput from '@/components/form/SerializableFilePickerInput'
import { REVIEW_COMMERCIAL_AGREEMENT_FORM_FIELDS } from '@/components/misc/CommercialAgreementsDetails/constants'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { useIsMinWidthSm } from '@/hooks/useIsMinWidthSm'
import { EXISTING_AGREEMENT_MAX_FILE_SIZE_MB } from '@/lib/constants'
import { truncateText } from '@/lib/helpers/helperFunctions'
import { PanelItemCommercialAgreement } from '@/types/responses/panels'

interface Props {
  agreement?: PanelItemCommercialAgreement
  needsReview: boolean
}

const ExistingAgreements: React.FC<Props> = ({ agreement, needsReview }) => {
  const currentCompany = useCurrentCompanyOrFail()
  const files = agreement?.commercialAgreementFiles || []
  const isMinWidthSm = useIsMinWidthSm()

  const hasAlreadyUploadedFile = files.some(
    (file) => file.company.id === currentCompany.id,
  )

  const canUploadFile = needsReview && !hasAlreadyUploadedFile

  if (files.length === 0 && !canUploadFile) {
    return <span className="text-dim">None</span>
  }

  return (
    <section
      className="flex flex-col justify-end gap-2"
      style={{ maxWidth: isMinWidthSm ? '400px' : undefined }}
    >
      {files.map((file) => {
        return (
          <div className="flex flex-col" key={file.fileName}>
            <a href={file.fileUrl} target="_blank" rel="noreferrer">
              {truncateText(file.fileName, {
                maxLength: 50,
                truncateLength: 35,
              })}
            </a>

            <span className="text-dim xxs" style={{ marginTop: '-3px' }}>
              (Added by {file.company.presentationName})
            </span>
          </div>
        )
      })}

      {canUploadFile && (
        <div
          className="flex w-full flex-row justify-start gap-1 sm:w-auto
            sm:justify-end"
        >
          <SerializableFilePickerInput
            name={REVIEW_COMMERCIAL_AGREEMENT_FORM_FIELDS.existingAgreementFile}
            buttonLabel="Upload existing agreement"
            buttonSize="sm"
            removeButtonClassName="text-xs"
            maxSizeMb={EXISTING_AGREEMENT_MAX_FILE_SIZE_MB}
          />
        </div>
      )}
    </section>
  )
}

export default ExistingAgreements
